<template lang="pug">
b-modal#resetThreshold(
  ref="resetThreshold"
  :title="$t('ui.combine.reset_threshold')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$tc('ui.banks', 1)" disabled).mb-0
      BankLookup(
        ref="bank"
        size="sm"
        required
        type="array"
        :dirty="$v.bank.$dirty"
        :error="$v.bank.$error"
        v-model.trim.lazy="$v.bank.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.bank" :name="$tc('ui.banks', 1)")
    b-form-group(:label="$t('ui.bank_acc_no')" disabled).mb-0
      DebounceInput(
        size="sm"
        required
        type="text"
        :dirty="$v.bank_acc_no.$dirty"
        :error="$v.bank_acc_no.$error"
        v-model.trim.lazy="$v.bank_acc_no.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.bank_acc_no" :name="$t('ui.bank_acc_no')")
    div(v-if="item")
      b-form-group(:label="$t('ui.threshold')")
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover
            thead.thead-light
              tr
                th
                  span &nbsp;
                th.text-center
                  span {{ $t('ui.amount') }}
                th.text-center
                  span {{ $t('ui.frequency') }}
            tbody
              tr(v-if="item.bank_acc_type.toUpperCase() != 'OUTGOING'")
                td
                  span.font-weight-bold.text-uppercase {{ $t('ui.incoming') }}
                td.text-center
                  //- span
                  //-   input(type="checkbox" v-model="incoming_amount_threshold").checkbox
                  label.custom-switch
                    input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="incoming_amount_threshold")
                    span.custom-switch-indicator
                td.text-center
                  //- span
                  //-   input(type="checkbox" v-model="incoming_frequency_threshold").checkbox
                  label.custom-switch
                    input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="incoming_frequency_threshold")
                    span.custom-switch-indicator
              tr(v-if="item.bank_acc_type.toUpperCase() != 'INCOMING'")
                td
                  span.font-weight-bold.text-uppercase {{ $t('ui.outgoing') }}
                td.text-center
                  //- span
                  //-   input(type="checkbox" v-model="outgoing_amount_threshold").checkbox
                  label.custom-switch
                    input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="outgoing_amount_threshold")
                    span.custom-switch-indicator
                td.text-center
                  //- span
                  //-   input(type="checkbox" v-model="outgoing_frequency_threshold").checkbox
                  label.custom-switch
                    input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="outgoing_frequency_threshold")
                    span.custom-switch-indicator
    div.row
      div.col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, numeric, helpers } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import BankLookup from "@/library/BankLookup";
import BankAccType from "@/library/BankAccType";
const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    BankLookup,
    BankAccType
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      bank: "",
      bank_acc_no: "",
      incoming_amount_threshold: false,
      incoming_frequency_threshold: false,
      outgoing_amount_threshold: false,
      outgoing_frequency_threshold: false,
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    atLeastOneChecked() {
      // This computed property will check if at least one checkbox is checked
      return this.incoming_amount_threshold || this.incoming_frequency_threshold || this.outgoing_amount_threshold || this.outgoing_frequency_threshold;
    },
  },
  validations: {
    bank: {
      required
    },
    bank_acc_no: {
      required,
      // integer,
      // minLength: minLength(6),
      // maxLength: maxLength(20)
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if(!this.atLeastOneChecked) {
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("message.atLeastOneChecked"), "error");
          return;
        }

        let url = config.bankResetUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          bank_id: this.bank.split(' - ')[0].trim(),
          bank_acc_no: this.bank_acc_no.trim(),
          incoming_amount_threshold: this.incoming_amount_threshold,
          incoming_frequency_threshold: this.incoming_frequency_threshold,
          outgoing_amount_threshold: this.outgoing_amount_threshold,
          outgoing_frequency_threshold: this.outgoing_frequency_threshold,
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.resetThreshold.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "reset_threshold", this.feedback.status);
                  this.$refs.resetThreshold.hide();
                }
              }
            } catch (error) {
              // console.log(error)
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.bank = (this.item.bank_id + ' - ' + this.item.bank_name).toUpperCase();
      this.bank_acc_no = this.item.bank_acc_no;
      this.incoming_amount_threshold = false;
      this.incoming_frequency_threshold = false;
      this.outgoing_amount_threshold = false;
      this.outgoing_frequency_threshold = false;
    }
  }
};
</script>

